function Footer() {
  return (
    <footer className="attribution">
      Challenge by
      <a
        href="https://www.frontendmentor.io?ref=challenge"
        target="_blank"
        rel="noreferrer"
      >
        Frontend Mentor.
      </a>
      Coded by <a href="https://tomiwa-portfolio.netlify.app">Tomiwa </a> ©2023
      .
    </footer>
  );
}

export default Footer;
